'use strict';

var _require = require('./ReactHeight'),
    ReactHeight = _require.ReactHeight;

ReactHeight.ReactHeight = ReactHeight;
module.exports = ReactHeight;


//////////////////
// WEBPACK FOOTER
// ./~/react-height/lib/index.js
// module id = 642
// module chunks = 0